/* eslint no-param-reassign: 0 */

import _ from 'underscore';
import ExtensionsRepository from '@bingads-webui-campaign-legacy/adextension-shared/service/repos/extensions';
import AssociationsRepository from '@bingads-webui-campaign-legacy/adextension-shared/service/repos/associations';

const baseSchema = window.globalLegacySchema.get('AdExtension');

const standardProperties = [baseSchema.key, 'Scheduling'];
const commonProperties = _.difference(_.keys(baseSchema.properties), standardProperties);

export default class Repository {
  constructor(options) {
    let ownedProperties = _.difference(_.keys(options.schema.properties), commonProperties);

    options = _.extend({
      afterChangeComitted: _.noop,
      extensionDataFormatter: _.partial(_.map, _, _.partial(_.pick, _, ownedProperties)),
      associationsDataFormatter: _.partial(_.pluck, _, 'AdExtension'),
    }, options);

    this.extension = new ExtensionsRepository(options);
    this.association = new AssociationsRepository(options);
  }
}
